'use client';

import { useBackButton } from '@/contexts/HeaderContext';
import MarketDetail from './detail/market/MarketDetail';

export default function MarketDetailPage({ id }: { id?: string }) {
  useBackButton(true);
  return <MarketDetail id={id} />;
}
